import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {GalleryState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class GalleryQuery extends QueryEntity<GalleryState> {

  constructor(protected store: Store) {
    super(store);
  }

}
